import React from "react";
import classes from "./customer.module.css";
import { TableRow, TableCell, Typography, Chip, Avatar } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import DonutChart from "../Dashboard/DonutChart";
import {
  stringAvatar,
  generateColor,
  resolveFileUrl,
} from "../../../Utilities/commonfunctions";
import moment from "moment";

function CustomerListItem(Props) {
  const subChartData = [
    { name: "Expired", value: Number(Props?.customer?.SubscriptionData?.expired) || 0 },
    { name: "Expiring Soon", value: Number(Props?.customer?.SubscriptionData?.expiry_soon) || 0 },
    { name: "Active", value: Number(Props?.customer?.SubscriptionData?.active) || 0 },
  ];
  //console.log(Props.customer.company.company_name );

  const navigate = useNavigate();
  function getTruncatedAddress(addressPart) {
    if (!addressPart) return ""; // Handle undefined or null inputs
    return addressPart.length > 50
      ? addressPart.substring(0, 50) + "..."
      : addressPart;
  }

  // Example usage

  return (
    <TableRow
      className={`${classes.table_bg}`}
      onClick={() => navigate(`/customer/profile/${Props.customer._id}`)}
    >
      <TableCell data-label="Customer">
        <Typography> {Props?.customer?.company[0]?.company_name}</Typography>
      </TableCell>
      <TableCell
        data-label="Contact Person"
        className={classes.AvatarContainer}
        style={{ height: "120px" }}
      >
        {Props?.customer?.user[0]?.profile_pic && (Props?.customer?.user[0]?.profile_pic?.filename || Props?.customer?.user[0]?.profile_pic?.location) ? (
          <Avatar
            alt="Remy Sharp"
            sx={{ width: 36 }}
            src={resolveFileUrl(Props?.customer?.user[0]?.profile_pic?.location || `${Props?.customer?.user[0]?.profile_pic?.destination}${Props?.customer?.user[0]?.profile_pic?.filename}`)}
          />
        ) : (
          <Avatar
            {...stringAvatar(
              `${Props?.customer?.first_name.trim()} ${Props?.customer?.last_name.trim()}`
            )}
            sx={{
              bgcolor: `${generateColor(
                `${Props?.customer?.first_name.trim()} ${Props?.customer?.last_name.trim()}`
              )}`,
            }}
            style={{ height: 36, width: 36 }}
          />
        )}
        <Typography className={classes.CustomerNameText}>
          {" "}
          {Props?.customer?.user[0]?.name}
        </Typography>
        {/* <img
                    src="assets/images/IM_Profile.png"
                    alt=""
                    className="avatar-xs rounded-circle me-2"
                /> */}
        {/* <a href="#javascript: void(0);" className="text-body align-middle">
                    {Props?.customer?.first_name}
                </a> */}
      </TableCell>
      <TableCell data-label="Email">
        {Props?.customer?.user[0]?.email || "—"}
      </TableCell>
      <TableCell data-label="Phone">
        {Props?.customer?.user[0]?.phone || "—"}
      </TableCell>
      <TableCell data-label="Location" style={{ minWidth: "230px" }}>{`${getTruncatedAddress(
        Props?.customer?.company[0]?.address_one
      )},${getTruncatedAddress(
        Props?.customer?.company[0]?.address_two
      )} `}</TableCell>
      <TableCell data-label="Industry" style={{ textTransform: "capitalize" }}>
        {Props?.customer?.company[0]?.industry}
      </TableCell>
      <TableCell data-label="Subscriptions" style={{ textAlign: "center" }}>
        <div className={classes.ChartContainer}>
          <DonutChart
            data={subChartData}
            colors={["#C52A38", "#240051", "#227DC3"]}
            size={56}
            thickness={0.42}
            centerValue={Props?.customer?.SubscriptionData?.total ?? 0}
            centerValueSize={15}
          />
          <div className={classes.hoverDiv}>
            <Typography className={classes.displayFlex}>
              <Avatar
                sx={{
                  bgcolor: `#C52A38`,
                  width: "8px",
                  height: "8px",
                }}
              >
                {" "}
              </Avatar>
              <span className={classes.pieChartSubHEading}>Expired:</span>
              <b>{Props?.customer?.SubscriptionData.expired}</b>
            </Typography>
            <Typography className={classes.displayFlex}>
              <Avatar
                sx={{
                  bgcolor: `#240051`,
                  width: "8px",
                  height: "8px",
                }}
              >
                {" "}
              </Avatar>
              <span className={classes.pieChartSubHEading}>Expiring Soon:</span>
              <b>{Props?.customer?.SubscriptionData.expiry_soon}</b>
            </Typography>
            <Typography className={classes.displayFlex}>
              <Avatar
                sx={{
                  bgcolor: `#227DC3`,
                  width: "8px",
                  height: "8px",
                }}
              >
                {" "}
              </Avatar>
              <span className={classes.pieChartSubHEading}>Active :</span>
              <b>{Props?.customer?.SubscriptionData.active}</b>
            </Typography>
          </div>
        </div>
      </TableCell>
      <TableCell data-label="Created">
        {moment(Props?.customer?.createdAt).format("DD MMM YYYY")}
      </TableCell>
      <TableCell data-label="Status">
        <Chip
          label={Props?.customer?.is_active ? "Active" : "Inactive"}
          size="small"
          style={{
            backgroundColor: Props?.customer?.is_active ? "#E9F7EC" : "#FCE3E5",
            color: Props?.customer?.is_active ? "#317D41" : "#BA1221",
            padding: "10px",
          }}
        />
      </TableCell>
      <TableCell style={{ width: 40, padding: "0 8px", color: "var(--tp-text-muted)" }}>
        <ChevronRightIcon fontSize="small" />
      </TableCell>
    </TableRow>
  );
}

export default CustomerListItem;
